import * as components from './components'

export default [
  {
    path: '/job/board',
    component: components.JobBoard,
    name: 'jobBoard',
    props: true
  },
  {
    path: '/job/applications',
    component: components.MyJobApplications,
    name: 'myJobApplications'
  },
  {
    path: '/job/:uuid/home',
    component: components.JobHome,
    name: 'jobHome',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/job/routes.js